export const interruptAction = async (interruptFunction: any, action: () => any) => {
  try {
    if (interruptFunction) {
      await interruptFunction();
    }
  } catch (e) {
    /* istanbul ignore next */
    if (e === 'cancel') {
      return;
    }

    /* istanbul ignore next */
    throw e;
  }

  return action();
};
